"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
var _typeof = require("@babel/runtime/helpers/typeof");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _regenerator = _interopRequireDefault(require("@babel/runtime/regenerator"));
var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));
var _asyncToGenerator2 = _interopRequireDefault(require("@babel/runtime/helpers/asyncToGenerator"));
var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));
var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));
var _assertThisInitialized2 = _interopRequireDefault(require("@babel/runtime/helpers/assertThisInitialized"));
var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));
var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));
var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));
var _react = _interopRequireWildcard(require("react"));
var dates = _interopRequireWildcard(require("@simplybenefits/sb-dates"));
var _Tabs = _interopRequireDefault(require("@mui/material/Tabs"));
var _Tab = _interopRequireDefault(require("@mui/material/Tab"));
var _Add = _interopRequireDefault(require("@mui/icons-material/Add"));
var _Download = _interopRequireDefault(require("@mui/icons-material/Download"));
var _FileCopy = _interopRequireDefault(require("@mui/icons-material/FileCopy"));
var _Upload = _interopRequireDefault(require("@mui/icons-material/Upload"));
var _ArrowBackRounded = _interopRequireDefault(require("@mui/icons-material/ArrowBackRounded"));
var _system = require("@mui/system");
var _Menu = _interopRequireDefault(require("@mui/material/Menu"));
var _MenuItem = _interopRequireDefault(require("@mui/material/MenuItem"));
var _theme = require("../../../theme");
var _Bubble = _interopRequireDefault(require("../../../components/Bubble"));
var _Button = _interopRequireDefault(require("../../../components/Button"));
var _Text = _interopRequireDefault(require("../../../components/Text"));
var _Tooltip = _interopRequireDefault(require("../../../components/Tooltip"));
var _PlanDesignForm = _interopRequireDefault(require("./PlanDesignForm"));
var _Revisions = _interopRequireDefault(require("./Revisions"));
var _FormModal = _interopRequireDefault(require("../../../components/Modals/FormModal"));
var _Loader = _interopRequireDefault(require("../../../components/Loader"));
var _HeaderDiv = _interopRequireDefault(require("../../../components/HeaderDiv"));
var Services = _interopRequireWildcard(require("../../../services"));
var _DateInput = _interopRequireDefault(require("../../../components/TextFields/DateInput"));
var _DropZoneModal = _interopRequireDefault(require("../../../components/Modals/DropZoneModal"));
var _papaparse = _interopRequireDefault(require("papaparse"));
var _i18n = _interopRequireDefault(require("../../../localization/i18n"));
var _tokens = _interopRequireDefault(require("../../../localization/tokens"));
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != _typeof(e) && "function" != typeof e) return { "default": e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n["default"] = e, t && t.set(e, n), n; }
function _callSuper(t, o, e) { return o = (0, _getPrototypeOf2["default"])(o), (0, _possibleConstructorReturn2["default"])(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], (0, _getPrototypeOf2["default"])(t).constructor) : o.apply(t, e)); }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
var ContentBlock = (0, _system.styled)('div')({
  backgroundColor: _theme.colors.surface,
  boxShadow: '0 1px 2px rgba(0, 0, 0, .15)',
  display: 'block',
  margin: 'auto auto 30px auto',
  padding: '30px',
  position: 'relative',
  zIndex: 4
});
var HeaderTitleBlock = (0, _system.styled)('div')({
  display: 'flex',
  flex: 1,
  flexDirection: 'row',
  alignItems: 'center'
});
var AddIconStyled = (0, _system.styled)(_Add["default"])(function (_ref) {
  var theme = _ref.theme;
  return {
    color: theme.palette.primary.main,
    fontSize: 16,
    padding: 0
  };
});
var DownloadIconStyled = (0, _system.styled)(_Download["default"])(function (_ref2) {
  var theme = _ref2.theme;
  return {
    color: theme.palette.primary.main,
    fontSize: 16,
    padding: 0
  };
});
var CloneIconStyled = (0, _system.styled)(_FileCopy["default"])(function (_ref3) {
  var theme = _ref3.theme;
  return {
    color: theme.palette.primary.main,
    fontSize: 16,
    padding: 0
  };
});
var UploadIconStyled = (0, _system.styled)(_Upload["default"])(function (_ref4) {
  var theme = _ref4.theme;
  return {
    color: theme.palette.primary.main,
    fontSize: 16,
    padding: 0
  };
});
var PlanDesign = /*#__PURE__*/function (_PureComponent) {
  function PlanDesign() {
    var _this;
    (0, _classCallCheck2["default"])(this, PlanDesign);
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    return (0, _possibleConstructorReturn2["default"])(_this, (_this = _callSuper(this, PlanDesign, [].concat(args)), _this.state = {
      value: 0,
      designIDs: _this.props.designs[_this.props.selectedClassID] ? Object.keys(_this.props.designs[_this.props.selectedClassID]).sort(function (a, b) {
        return _this.props.designs[_this.props.selectedClassID][a].title.replace('Design ', '') - _this.props.designs[_this.props.selectedClassID][b].title.replace('Design ', '');
      }) // Order designIDs by design number
      : [],
      selectedDesignID: null,
      showingRevisions: false,
      unSavedChangesMade: false,
      showSaveMessageDialog: false,
      dialogCallback: null,
      effectiveDate: dates.getUTC(new Date(), 'YYYY/MM/DD'),
      showEffectiveDateDialog: false,
      anchorElUpload: null,
      anchorElDownload: null,
      errors: {
        lifeInsurance: {},
        deathDismemberment: {},
        dependentLife: {},
        std: {},
        ltd: {},
        criticalIllness: {},
        drugs: {},
        healthcare: {},
        outOfCountry: {},
        efap: {},
        virtualHealthcare: {},
        financialAwareness: {},
        dental: {},
        spendingAccounts: {}
      }
    }, _this._downloadPlanDesignJson = function () {
      var classID = _this.props.selectedClassID;
      var planDesign = _this.props.designs[classID][_this.state.selectedDesignID];
      var link = document.createElement('a');
      link.href = "data:text/json;charset=utf-8,".concat(encodeURIComponent(JSON.stringify(planDesign)));
      link.setAttribute('download', "".concat(classID, "_").concat(_this.state.selectedDesignID, ".json"));
      link.setAttribute('target', "_blank");
      document.body.appendChild(link);
      link.click();
    }, _this._downloadPlanDesignCsv = /*#__PURE__*/(0, _asyncToGenerator2["default"])( /*#__PURE__*/_regenerator["default"].mark(function _callee() {
      var classID, planDesign, planDesignBenefitKeys, csv, keys, _i, _keys, key, lines, link;
      return _regenerator["default"].wrap(function _callee$(_context) {
        while (1) switch (_context.prev = _context.next) {
          case 0:
            classID = _this.props.selectedClassID;
            planDesign = _this.props.designs[classID][_this.state.selectedDesignID];
            planDesignBenefitKeys = {
              'lifeInsurance': 'LIFE INSURANCE',
              'deathDismemberment': 'DEATH & DISMEMBERMENT',
              'dependentLife': 'DEPENDENT LIFE',
              'std': "STD",
              'ltd': "LTD",
              'criticalIllness': "CRITICAL ILLNESS",
              'drugs': "DRUGS",
              'healthcare': "HEALTHCARE",
              'outOfCountry': "OUT OF COUNTRY",
              'efap': "EFAP",
              'virtualHealthcare': "VIRTUAL HEALTHCARE",
              'financialAwareness': "FINANCIAL AWARENESS",
              'dental': "DENTAL",
              'spendingAccounts': "SPENDING ACCOUNTS"
            };
            csv = '';
            keys = Object.keys(planDesignBenefitKeys);
            _i = 0, _keys = keys;
          case 6:
            if (!(_i < _keys.length)) {
              _context.next = 16;
              break;
            }
            key = _keys[_i];
            // Add the title as a separator line
            csv += "\n".concat(planDesignBenefitKeys[key], "\n");

            // eslint-disable-next-line no-await-in-loop
            _context.next = 11;
            return _papaparse["default"].unparse([planDesign[key]]);
          case 11:
            lines = _context.sent;
            csv += "".concat(lines, "\n");
          case 13:
            _i++;
            _context.next = 6;
            break;
          case 16:
            link = document.createElement('a');
            link.href = "data:text/csv;charset=utf-8,".concat(csv);
            link.setAttribute('download', "".concat(classID, "_").concat(_this.state.selectedDesignID, ".csv"));
            link.setAttribute('target', "_blank");
            document.body.appendChild(link);
            link.click();
          case 22:
          case "end":
            return _context.stop();
        }
      }, _callee);
    })), _this._uploadPlanDesign = function (files) {
      var reader = new FileReader();
      reader.onload = function (e) {
        var planDesign = JSON.parse(e.target.result);
        _this.props.createPlanDesignFromUpload(_this.props.selectedClassID, planDesign);
      };
      reader.readAsText(files[0]);
      _this.setState({
        uploadPlanDesignModalOpen: false
      });
    }, _this._handleTabChange = function (event, value) {
      if (_this.state.unSavedChangesMade) {
        _this.setState({
          showSaveMessageDialog: true,
          dialogCallback: function dialogCallback() {
            _this.setState({
              value: value,
              selectedDesignID: _this.state.designIDs[value]
            });
          }
        });
        return;
      }
      _this.setState({
        value: value,
        selectedDesignID: _this.state.designIDs[value]
      });
    }, _this._validateEffectiveDate = /*#__PURE__*/(0, _asyncToGenerator2["default"])( /*#__PURE__*/_regenerator["default"].mark(function _callee2() {
      var effectiveDateError, startOfMonth, effectiveDateUTC;
      return _regenerator["default"].wrap(function _callee2$(_context2) {
        while (1) switch (_context2.prev = _context2.next) {
          case 0:
            _context2.next = 2;
            return Services.validateInput('effectiveDate', _this.state.effectiveDate);
          case 2:
            effectiveDateError = _context2.sent;
            startOfMonth = dates.getStartOfMonth();
            effectiveDateUTC = dates.getUTC(_this.state.effectiveDate);
            if (effectiveDateUTC < startOfMonth) {
              effectiveDateError = _i18n["default"].t(_tokens["default"].labels.planDesign.planDesignChangesBackdated);
            }
            _context2.next = 8;
            return _this.setState({
              effectiveDateError: effectiveDateError
            });
          case 8:
            if (!effectiveDateError) {
              _context2.next = 10;
              break;
            }
            return _context2.abrupt("return", false);
          case 10:
            return _context2.abrupt("return", true);
          case 11:
          case "end":
            return _context2.stop();
        }
      }, _callee2);
    })), _this._saveDesign = /*#__PURE__*/(0, _asyncToGenerator2["default"])( /*#__PURE__*/_regenerator["default"].mark(function _callee3() {
      var revision,
        effectiveDateValid,
        success,
        content,
        _args3 = arguments;
      return _regenerator["default"].wrap(function _callee3$(_context3) {
        while (1) switch (_context3.prev = _context3.next) {
          case 0:
            revision = _args3.length > 0 && _args3[0] !== undefined ? _args3[0] : false;
            if (!(!_this.state.selectedDesignID || _this.props.overrideModularView)) {
              _context3.next = 3;
              break;
            }
            return _context3.abrupt("return", null);
          case 3:
            if (!(_this.props.currentAccountMeta.state >= 3 && !_this.props.isMasterSite)) {
              _context3.next = 5;
              break;
            }
            return _context3.abrupt("return", null);
          case 5:
            if (!_this.props.isMasterSite) {
              _context3.next = 11;
              break;
            }
            _context3.next = 8;
            return _this._validateEffectiveDate();
          case 8:
            effectiveDateValid = _context3.sent;
            if (effectiveDateValid) {
              _context3.next = 11;
              break;
            }
            return _context3.abrupt("return", null);
          case 11:
            _context3.next = 13;
            return _this.props.savePlanDesign(_this.state.selectedDesignID, revision || _this.props.designs[_this.props.selectedClassID][_this.state.selectedDesignID], _this.props.isMasterSite ? dates.getUTC(_this.state.effectiveDate) : null);
          case 13:
            success = _context3.sent;
            if (success) {
              _this.setState({
                unSavedChangesMade: false,
                effectiveDate: dates.getUTC(new Date(), 'YYYY/MM/DD'),
                showEffectiveDateDialog: false
              });
              content = document.getElementById("content");
              if (content) {
                document.getElementById("content").scroll(0, 0);
              } else {
                window.scrollTo(0, 0);
              }
            }
            return _context3.abrupt("return", null);
          case 16:
          case "end":
            return _context3.stop();
        }
      }, _callee3);
    })), _this._toggleEffectiveDateDialog = function () {
      _this.setState({
        showEffectiveDateDialog: !_this.state.showEffectiveDateDialog
      });
    }, _this._setChangesMadeFlag = function () {
      _this.setState({
        unSavedChangesMade: true
      });
    }, _this._createPlanDesign = function () {
      _this.props.createPlanDesign(_this.props.selectedClassID);
    }, _this._clonePlanDesign = /*#__PURE__*/(0, _asyncToGenerator2["default"])( /*#__PURE__*/_regenerator["default"].mark(function _callee4() {
      return _regenerator["default"].wrap(function _callee4$(_context4) {
        while (1) switch (_context4.prev = _context4.next) {
          case 0:
            _context4.next = 2;
            return _this.props.clonePlanDesign(_this.props.selectedClassID, _this.state.selectedDesignID);
          case 2:
          case "end":
            return _context4.stop();
        }
      }, _callee4);
    })), _this._toggleRevisions = function () {
      _this.setState({
        showingRevisions: !_this.state.showingRevisions
      });
    }, _this.setAnchorEl = function (type, anchorEl) {
      _this.setState((0, _defineProperty2["default"])({}, type, anchorEl));
    }, (0, _assertThisInitialized2["default"])(_this)));
  }
  (0, _inherits2["default"])(PlanDesign, _PureComponent);
  return (0, _createClass2["default"])(PlanDesign, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      this.setState({
        selectedDesignID: this.state.designIDs[0]
      });
    }
  }, {
    key: "componentWillUnmount",
    value: (
    /**
     * On Unmount, clear the auto save and do a final save
     */
    function () {
      var _componentWillUnmount = (0, _asyncToGenerator2["default"])( /*#__PURE__*/_regenerator["default"].mark(function _callee5() {
        var confirm;
        return _regenerator["default"].wrap(function _callee5$(_context5) {
          while (1) switch (_context5.prev = _context5.next) {
            case 0:
              if (!(this.state.unSavedChangesMade && !this.props.overrideModularView)) {
                _context5.next = 5;
                break;
              }
              confirm = window.confirm(_i18n["default"].t(_tokens["default"].labels.planDesign.saveChangesConfirmation));
              if (!confirm) {
                _context5.next = 5;
                break;
              }
              _context5.next = 5;
              return this._saveDesign(false);
            case 5:
            case "end":
              return _context5.stop();
          }
        }, _callee5, this);
      }));
      function componentWillUnmount() {
        return _componentWillUnmount.apply(this, arguments);
      }
      return componentWillUnmount;
    }()
    /**
     * @param event
     * @param value
     * @private
     */
    )
  }, {
    key: "render",
    value: function render() {
      var _this2 = this;
      var _this$props = this.props,
        designs = _this$props.designs,
        selectedClassID = _this$props.selectedClassID,
        selectedClass = _this$props.selectedClass,
        isMasterSite = _this$props.isMasterSite;
      var whitelabel = this.props.whitelabel || {};
      if (this.state.showingRevisions) {
        return /*#__PURE__*/_react["default"].createElement(_Revisions["default"], {
          isMasterSite: isMasterSite,
          isQuote: this.props.isQuote,
          whitelabel: whitelabel,
          designs: designs,
          currentAccountMeta: this.props.currentAccountMeta,
          selectedClassID: selectedClassID,
          selectedDesignID: this.state.selectedDesignID,
          getPlanDesignRevisions: this.props.getPlanDesignRevisions,
          getSinglePlanDesignRevision: this.props.getSinglePlanDesignRevision,
          revertToRevision: this.props.revertToRevision,
          goBack: this._toggleRevisions,
          saveDesign: this._saveDesign,
          overrideModularView: this.props.overrideModularView,
          loading: this.props.loading
        });
      }
      var orderedDesigns = Object.keys(designs[this.props.selectedClassID]).sort(function (a, b) {
        return designs[_this2.props.selectedClassID][a].title.replace('Design ', '') - designs[_this2.props.selectedClassID][b].title.replace('Design ', '');
      });
      return /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null, /*#__PURE__*/_react["default"].createElement(ContentBlock, null, /*#__PURE__*/_react["default"].createElement(_HeaderDiv["default"], null, /*#__PURE__*/_react["default"].createElement(HeaderTitleBlock, null, /*#__PURE__*/_react["default"].createElement(_Button["default"], {
        customStyle: {
          minWidth: "26px",
          width: "30px",
          marginRight: "5px",
          marginLeft: "-5px",
          padding: "2px"
        },
        onClick: this.props.goBack,
        transparent: true
      }, /*#__PURE__*/_react["default"].createElement(_ArrowBackRounded["default"], null)), /*#__PURE__*/_react["default"].createElement(_Text["default"], {
        large: true,
        bold: true,
        display: "block",
        margin: "20px 0"
      }, _i18n["default"].t(_tokens["default"].labels.planDesign.buildAQuote)), !this.props.isPrivateLabelAdvisor && (this.props.currentAccountMeta.state <= 3 || this.props.isRevision) && /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null, /*#__PURE__*/_react["default"].createElement(_Button["default"], {
        transparent: true,
        color: "primary",
        "aria-controls": this.state.anchorElUpload ? 'demo-positioned-menu' : undefined,
        "aria-haspopup": "true",
        "aria-expanded": this.state.anchorElUpload ? 'true' : undefined,
        onClick: function onClick(e) {
          return _this2.setAnchorEl('anchorElUpload', e.currentTarget);
        },
        customStyle: {
          textTransform: "capitalize",
          fontSize: 14,
          color: whitelabel.primaryColor || _theme.colors.skyBlue
        }
      }, /*#__PURE__*/_react["default"].createElement(AddIconStyled, null), " ", _i18n["default"].t(_tokens["default"].labels.planDesign.addDesign)), /*#__PURE__*/_react["default"].createElement(_Menu["default"], {
        id: "demo-positioned-menu",
        "aria-labelledby": "demo-positioned-button",
        anchorEl: this.state.anchorElUpload,
        open: Boolean(this.state.anchorElUpload),
        onClose: function onClose() {
          return _this2.setAnchorEl('anchorElUpload', null);
        },
        anchorOrigin: {
          vertical: 'top',
          horizontal: 'left'
        },
        transformOrigin: {
          vertical: 'top',
          horizontal: 'left'
        }
      }, /*#__PURE__*/_react["default"].createElement(_MenuItem["default"], {
        onClick: function onClick() {
          _this2.setAnchorEl('anchorElUpload', null);
          _this2._createPlanDesign();
        }
      }, /*#__PURE__*/_react["default"].createElement(AddIconStyled, {
        style: {
          marginRight: "10px"
        }
      }), " ", _i18n["default"].t(_tokens["default"].labels.planDesign.newBlankDesign)), Object.keys(designs[selectedClassID]).length > 0 && /*#__PURE__*/_react["default"].createElement(_MenuItem["default"], {
        onClick: function onClick() {
          _this2.setAnchorEl('anchorElUpload', null);
          _this2._clonePlanDesign();
        }
      }, /*#__PURE__*/_react["default"].createElement(CloneIconStyled, {
        style: {
          marginRight: "10px"
        }
      }), " ", _i18n["default"].t(_tokens["default"].labels.planDesign.cloneDesign)), isMasterSite && /*#__PURE__*/_react["default"].createElement(_MenuItem["default"], {
        onClick: function onClick() {
          _this2.setAnchorEl('anchorElUpload', null);
          _this2.setState({
            uploadPlanDesignModalOpen: true
          });
        }
      }, /*#__PURE__*/_react["default"].createElement(UploadIconStyled, {
        style: {
          marginRight: "10px"
        }
      }), " ", _i18n["default"].t(_tokens["default"].labels.planDesign.uploadDesign)))), isMasterSite && /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null, /*#__PURE__*/_react["default"].createElement(_Button["default"], {
        transparent: true,
        customStyle: {
          height: 50,
          width: 150,
          textTransform: "capitalize",
          fontSize: 14,
          color: whitelabel.primaryColor || _theme.colors.skyBlue
        },
        "aria-controls": this.state.anchorElDownload ? 'demo-positioned-menu' : undefined,
        "aria-haspopup": "true",
        "aria-expanded": this.state.anchorElDownload ? 'true' : undefined,
        onClick: function onClick(e) {
          return _this2.setAnchorEl('anchorElDownload', e.currentTarget);
        }
      }, /*#__PURE__*/_react["default"].createElement(DownloadIconStyled, {
        style: {
          marginRight: 5
        }
      }), " Download Design"), /*#__PURE__*/_react["default"].createElement(_Menu["default"], {
        id: "demo-positioned-menu",
        "aria-labelledby": "demo-positioned-button",
        anchorEl: this.state.anchorElDownload,
        open: Boolean(this.state.anchorElDownload),
        onClose: function onClose() {
          return _this2.setAnchorEl('anchorElDownload', null);
        },
        anchorOrigin: {
          vertical: 'top',
          horizontal: 'left'
        },
        transformOrigin: {
          vertical: 'top',
          horizontal: 'left'
        }
      }, /*#__PURE__*/_react["default"].createElement(_MenuItem["default"], {
        onClick: function onClick() {
          _this2.setAnchorEl('anchorElDownload', null);
          _this2._downloadPlanDesignJson();
        }
      }, /*#__PURE__*/_react["default"].createElement(DownloadIconStyled, {
        style: {
          marginRight: 5
        }
      }), " Download JSON Design (Uploadable)"), /*#__PURE__*/_react["default"].createElement(_MenuItem["default"], {
        onClick: function onClick() {
          _this2.setAnchorEl('anchorElDownload', null);
          _this2._downloadPlanDesignCsv();
        }
      }, /*#__PURE__*/_react["default"].createElement(DownloadIconStyled, {
        style: {
          marginRight: 5
        }
      }), " Download CSV Design")))), !this.props.isPrivateLabelAdvisor && designs[selectedClassID] && Object.keys(designs[selectedClassID]).length > 0 && /*#__PURE__*/_react["default"].createElement(_Button["default"], {
        color: "white",
        customStyle: {
          height: 50,
          width: 180,
          textTransform: "capitalize",
          fontSize: 16,
          marginRight: 1.25
        },
        onClick: this._toggleRevisions,
        noHover: true
      }, _i18n["default"].t(_tokens["default"].labels.planDesign.viewRevisions)), (isMasterSite || this.props.currentAccountMeta.state <= 3) && this.state.selectedDesignID && /*#__PURE__*/_react["default"].createElement(_Button["default"], {
        customStyle: {
          height: 50,
          fontSize: 16,
          textTransform: "capitalize"
        },
        onClick: function onClick() {
          // if we are saving a normal plan design from the master site then ask for an effective date
          if (isMasterSite && !_this2.props.isQuote && !_this2.props.isRevision) {
            _this2._toggleEffectiveDateDialog();
          } else {
            _this2._saveDesign(false);
          }
        },
        color: "primary"
      }, _i18n["default"].t(_tokens["default"].labels.planDesign.saveDesign))), selectedClass.description ? /*#__PURE__*/_react["default"].createElement(_Tooltip["default"], {
        tip: selectedClass.description,
        placement: "top",
        arrow: true,
        display: "inline-block"
      }, /*#__PURE__*/_react["default"].createElement(_Bubble["default"], {
        label: "".concat(_i18n["default"].t(_tokens["default"].titles["class"]), ": ").concat(selectedClass.title),
        isSelected: true,
        clickable: false
      })) : /*#__PURE__*/_react["default"].createElement(_Bubble["default"], {
        label: "".concat(_i18n["default"].t(_tokens["default"].titles["class"]), ": ").concat(selectedClass.title),
        isSelected: true,
        clickable: false
      }), !isMasterSite && this.props.currentAccountMeta.state > 3 && /*#__PURE__*/_react["default"].createElement(_Text["default"], {
        color: "red"
      }, _i18n["default"].t(_tokens["default"].labels.planDesign.planDesignsCannotBeChanged)), !designs[selectedClassID] || Object.keys(designs[selectedClassID]).length === 0 ? /*#__PURE__*/_react["default"].createElement(_Text["default"], {
        medium: true
      }, _i18n["default"].t(_tokens["default"].labels.planDesign.noPlanDesignsForClass)) : /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null, !this.props.isPrivateLabelAdvisor && /*#__PURE__*/_react["default"].createElement(_Tabs["default"], {
        value: this.state.value,
        onChange: this._handleTabChange,
        indicatorColor: "primary",
        textColor: "primary"
      }, orderedDesigns.map(function (designID, i) {
        var design = designs[selectedClassID][designID];
        return /*#__PURE__*/_react["default"].createElement(_Tab["default"], {
          key: "".concat(design.title, "-").concat(i),
          label: /*#__PURE__*/_react["default"].createElement(_Text["default"], {
            small: true,
            color: "primary"
          }, _i18n["default"].locale === "fr" ? design.title.replace("Design", "Conception") : design.title),
          sx: {
            width: 160,
            padding: '6px 12px'
          }
        });
      })), this.state.selectedDesignID && /*#__PURE__*/_react["default"].createElement(_PlanDesignForm["default"], {
        selectedDesignID: this.state.selectedDesignID,
        selectedClassID: selectedClassID,
        designs: designs,
        errors: this.state.errors,
        isMasterSite: isMasterSite,
        savePlanDesignBenefitInitData: this.props.savePlanDesignBenefitInitData,
        savePlanDesignField: this.props.savePlanDesignField,
        whitelabel: whitelabel,
        setChangesMadeFlag: this._setChangesMadeFlag,
        accountMeta: this.props.currentAccountMeta,
        isPrivateLabelAdvisor: this.props.isPrivateLabelAdvisor,
        language: this.props.language
      })), (isMasterSite || this.props.currentAccountMeta.state <= 3) && this.state.selectedDesignID && !this.props.overrideModularView && /*#__PURE__*/_react["default"].createElement(_Button["default"], {
        customStyle: {
          display: 'block',
          height: 50,
          fontSize: 16,
          textTransform: "capitalize",
          marginLeft: 'auto',
          marginTop: 3
        },
        onClick: function onClick() {
          // if we are saving a normal plan design from the master site then ask for an effective date
          if (isMasterSite && !_this2.props.isQuote && !_this2.props.isRevision) {
            _this2._toggleEffectiveDateDialog();
          } else {
            _this2._saveDesign(false);
          }
        },
        color: "primary"
      }, _i18n["default"].t(_tokens["default"].labels.planDesign.saveDesign))), /*#__PURE__*/_react["default"].createElement(_FormModal["default"], {
        open: this.state.showSaveMessageDialog,
        close: /*#__PURE__*/(0, _asyncToGenerator2["default"])( /*#__PURE__*/_regenerator["default"].mark(function _callee6() {
          return _regenerator["default"].wrap(function _callee6$(_context6) {
            while (1) switch (_context6.prev = _context6.next) {
              case 0:
                if (!_this2.state.dialogCallback) {
                  _context6.next = 3;
                  break;
                }
                _context6.next = 3;
                return _this2.state.dialogCallback();
              case 3:
                _this2.setState({
                  showSaveMessageDialog: false,
                  dialogCallback: null,
                  unSavedChangesMade: false
                });
              case 4:
              case "end":
                return _context6.stop();
            }
          }, _callee6);
        })),
        title: _i18n["default"].t(_tokens["default"].labels.planDesign.changesMade),
        disableBackdropClick: true,
        disableEscapeKeyDown: true,
        onSave: /*#__PURE__*/(0, _asyncToGenerator2["default"])( /*#__PURE__*/_regenerator["default"].mark(function _callee7() {
          return _regenerator["default"].wrap(function _callee7$(_context7) {
            while (1) switch (_context7.prev = _context7.next) {
              case 0:
                _context7.next = 2;
                return _this2._saveDesign(false);
              case 2:
                if (!_this2.state.dialogCallback) {
                  _context7.next = 5;
                  break;
                }
                _context7.next = 5;
                return _this2.state.dialogCallback();
              case 5:
                _this2.setState({
                  showSaveMessageDialog: false,
                  dialogCallback: null
                });
              case 6:
              case "end":
                return _context7.stop();
            }
          }, _callee7);
        })),
        saveButtonText: "Save"
      }, /*#__PURE__*/_react["default"].createElement(_Text["default"], {
        medium: true,
        light: true
      }, _i18n["default"].t(_tokens["default"].labels.planDesign.unsavedChanges)), this.props.loading && /*#__PURE__*/_react["default"].createElement(_Loader["default"], {
        whitelabel: this.props.whitelabel,
        customImageStyle: {
          top: '50%'
        }
      })), /*#__PURE__*/_react["default"].createElement(_FormModal["default"], {
        open: this.state.showEffectiveDateDialog,
        close: this._toggleEffectiveDateDialog,
        title: _i18n["default"].t(_tokens["default"].titles.setEffectiveDate),
        onSave: function onSave() {
          return _this2._saveDesign(false);
        },
        saveButtonText: "Submit"
      }, /*#__PURE__*/_react["default"].createElement(_Text["default"], {
        medium: true
      }, _i18n["default"].t(_tokens["default"].labels.pleaseProvideEffectiveDate)), /*#__PURE__*/_react["default"].createElement(_DateInput["default"], {
        label: "Effective Date",
        value: this.state.effectiveDate,
        onChange: function onChange(e) {
          _this2.setState({
            effectiveDate: e.target.value
          });
        },
        error: Boolean(this.state.effectiveDateError),
        helperText: this.state.effectiveDateError,
        fullWidth: true,
        required: true
      }), /*#__PURE__*/_react["default"].createElement(_Text["default"], {
        medium: true,
        margin: "10px 0 0 0"
      }, _i18n["default"].t(_tokens["default"].labels.changesAppliedOnEffectiveDate)), this.props.loading && /*#__PURE__*/_react["default"].createElement(_Loader["default"], {
        whitelabel: this.props.whitelabel,
        customImageStyle: {
          top: '50%'
        }
      })), /*#__PURE__*/_react["default"].createElement(_DropZoneModal["default"], {
        title: "Please upload the plan design file",
        hideModal: function hideModal() {
          _this2.setState({
            uploadPlanDesignModalOpen: false
          });
        },
        showModal: this.state.uploadPlanDesignModalOpen,
        maxItems: 1,
        type: "Plan Design Upload Form",
        submitFile: this._uploadPlanDesign,
        acceptedFiles: "text/json, .json"
      }), this.props.loading && /*#__PURE__*/_react["default"].createElement(_Loader["default"], {
        whitelabel: this.props.whitelabel
      }));
    }
  }], [{
    key: "getDerivedStateFromProps",
    value: function getDerivedStateFromProps(props, state) {
      // Order designIDs by design number
      var designIDs = props.designs[props.selectedClassID] ? Object.keys(props.designs[props.selectedClassID]).sort(function (a, b) {
        return props.designs[props.selectedClassID][a].title.replace('Design ', '') - props.designs[props.selectedClassID][b].title.replace('Design ', '');
      }) : [];
      if (designIDs.length !== state.designIDs.length) {
        return {
          designIDs: designIDs,
          value: designIDs.length - 1,
          selectedDesignID: designIDs[designIDs.length - 1]
        };
      }
      return null;
    }
  }]);
}(_react.PureComponent);
var _default = exports["default"] = PlanDesign;